module.exports = __webpack_public_path__ + "static/media/usc_logo.84b490a0.svg";